'use client';

import { c as _c } from "react/compiler-runtime";
import GalleryImagesNew from "./GalleryImagesNew";
export default function DpGalleryNew(t0) {
  const $ = _c(2);
  const {
    digitalProfile
  } = t0;
  let t1;
  if ($[0] !== digitalProfile) {
    t1 = <div className="relative "><GalleryImagesNew digitalProfile={digitalProfile} /></div>;
    $[0] = digitalProfile;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}